'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  ', ';\n  margin-left: 32px;\n  font-weight: 600;\n  text-align: center;\n  text-decoration: none;\n  color: #4a4a4a;\n  cursor: pointer;\n'], ['\n  ', ';\n  margin-left: 32px;\n  font-weight: 600;\n  text-align: center;\n  text-decoration: none;\n  color: #4a4a4a;\n  cursor: pointer;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _font = require('../../../util/font');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LINK = function LINK(props) {
  return _react2.default.createElement('a', props);
};
var LinkMenu = (0, _styledComponents2.default)(LINK)(_templateObject, _font.fontSemiSmall);

exports.default = LinkMenu;